export default class User {
  static myInstance = null;

  userID = "";
  selectedUser = "";
  selectedReferral = "";
  selectedReferralId = "";

  salons = [];

  /**
   * @returns {User}
   */
  static getInstance() {
    if (User.myInstance == null) {
      User.myInstance = new User();
    }

    return this.myInstance;
  }
}
